// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2lIk4","load4":"Spinner_load4__llAEN"};